export enum RecaptchaActions {
  ForgotPassword = 'forgot-password',
  SignUp = 'register',
}
